import {getLangSession} from 'api/storageApi'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {localLanguages} from 'constants/Language'
import {
  getMultiLanguageEEGReportApi,
  getMultiLanguageHRVReportApi,
  getMultiLanguageEEGMCIReportApi,
  getMultiLanguageHealthCenterReportApi,
} from 'api/languageApi'
import {useAppDispatch} from 'hooks'
import {
  LanguageState,
  updateReportLanguage,
} from 'features/languageReport/languageReportSlice'

export default function useLanguageReport(type: string, version?: number) {
  const {i18n} = useTranslation()

  const dispatch = useAppDispatch()

  const getMultiLangApi = async (lang: keyof LanguageState, type: string) => {
    try {
      let response
      switch (type) {
        case 'eeg':
          response = await getMultiLanguageEEGReportApi(lang)
          break
        case 'hrv':
          response = await getMultiLanguageHRVReportApi(lang)
          break
        case 'mci':
          response = await getMultiLanguageEEGMCIReportApi(lang, version ?? 1)
          break
        case 'health':
          response = await getMultiLanguageHealthCenterReportApi(
            lang,
            version ?? 1,
          )
          break
        default:
          throw new Error('Invalid type provided')
      }
      dispatch(
        updateReportLanguage({
          lang,
          type,
          data: JSON.parse(JSON.stringify(response).replaceAll('&nbsp;', ' ')),
        }),
      )
    } catch (error) {
      console.log('Error fetching multi-language API:', error)
    }
  }

  useEffect(() => {
    const lang = getLangSession()
    if (lang) {
      i18n.changeLanguage(lang)
    }
    getMultiLangApi(i18n.language, type)
  }, [i18n.language, type, version])

  const isLocalLanguage = localLanguages.includes(i18n.language)

  return {isLocalLanguage}
}
